import jwt_decode from "jwt-decode";
import { RouterModule, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { patterns } from 'src/utils/helpers/patterns';
import { AuthService } from '../../services/auth.service';
import { AlertService } from 'src/app/services/alert.service';
import { Component, OnInit, inject, Inject, PLATFORM_ID, signal, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { BtnNormalComponent } from "@app/shared/btn-normal/btn-normal.component";
import { environment } from "@environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterModule,
    ReactiveFormsModule,
    BtnNormalComponent
  ]
})
export class LoginComponent implements OnInit {

  formSend: any;
  isproduction = signal(environment.production)
  private fb = inject(UntypedFormBuilder)
  private router = inject(Router)
  private authService = inject(AuthService)
  private alertService = inject(AlertService)

  constructor(
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  ngOnInit(): void {
    this.initForm()
  }


  initForm() {
    this.formSend = this.fb.group({
      user: new UntypedFormControl("", [Validators.required, Validators.pattern(patterns.ALL_VALID_CHARACTERES)]),
      pass: new UntypedFormControl("", [Validators.required, Validators.pattern(patterns.ALL_VALID_CHARACTERES)])
    })
  }

  get ctlForm() {
    return this.formSend.controls
  }

  sendInfo() {
    if (this.formSend.invalid) {
      this.alertService.alert('error', 'Ingresa las credenciales');
      this.formSend.markAllAsTouched();
      return;
    }

    const { user, pass } = this.formSend.value
    let body: any = {}
    body.email = user;
    body.pass = pass;
    this.authService.initSesion(body)
      .subscribe(
        {
          next: (response) => {
            let person: any = this.validateToken(response.data.Token)

            isPlatformBrowser(this.platformId) && localStorage.setItem('infoPerson', JSON.stringify(person))
            if (person) {
              if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem('animalType', 'Bearer')
                localStorage.setItem('animal', response.data.Token)
                localStorage.setItem('typeAuth', person.typeAdmJWT)
              }
              person.typeAdmJWT == 'SA' && this.router.navigate(['admin/home'])
              person.typeAdmJWT == 'CO' && this.router.navigate(['colaborador/home'])
            }


          },
          error: (response) => {
            let errorMsg = 'Ocurrió un error inesperado al intentar iniciar sesión.';
            
            if (response.status === 0) {
              errorMsg = 'Error de conexión. Verifica tu internet o intenta más tarde.';
            } else if (response.status === 401 || response.status === 403) {
              errorMsg = response?.error?.message || 'Correo o contraseña incorrectos.';
            } else if (response.status >= 500) {
              errorMsg = 'Error en nuestros servidores. Por favor, intenta de nuevo más tarde.';
            } else if (response?.error?.message) {
              errorMsg = response.error.message;
            }

            this.alertService.alert('error', errorMsg);
          }
        }
      )
  }

  validateToken(tokenRec: string) {
    let decodedToken = jwt_decode(tokenRec)
    return decodedToken ? decodedToken : ''
  }

}
